
import { observer } from "mobx-react";
import {
  Typography,
  useTheme,
  IconButton,
  Grid,
  Box
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { MoreVert } from '@material-ui/icons';
import { DataGrid, GridColumnProps, Button, StandardDialog, SelectField, AgGridColumnProps } from '@roc/ui';
import { useEffect, useState } from "react";
import { AddContactsToCadenceModal } from "./marketing/addContactsToCadenceModal";
import { useStore } from '@roc/client-portal-shared/hooks';
import { businessUnitOptions } from "../leadsDashboard/allLeadDashboard";
import { LEAD_OBJECT_TYPE } from "../leads/constants/constants";



const columns: AgGridColumnProps[] = [
  {
    field: 'originatorName',
    headerName: 'Originator Name',
    minWidth: 160,
    cellRenderer: 'nameRenderer',
    comparator: () => 0,
  },
  {
    field: 'numberOfProspects',
    headerName: 'Number Prospects',
    minWidth: 120,
    comparator: () => 0,
  },
]

const useStyles = makeStyles((theme) => ({
  container: {
    marginTop: '0px',
  },
  peopleContainer: {
    minHeight: "400px",
    maxHeight: "500px",
    overflowY: "auto",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    gap: "10px",
    padding: "10px",
    backgroundColor: "white",
    borderRadius: "8px",
    marginTop: theme.spacing(5),
  },
  noStepsContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    marginTop: theme.spacing(10),
  },
  associateButtonContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
  },
}));

export const PorspectsByOriginatorDashboardTabV2 = observer(({ gritStore }) => {
  const { cadenceStore, globalStore } = useStore();
  const classes = useStyles();
  const { palette } = useTheme();
  const { cadence } = cadenceStore

  useEffect(() => {
    if (cadence.metrics.totalProspects > 0) {
      gritStore.fetchGridData();
    }
  }, [])

  const openMenu = (event, record) => {
    console.log('Open menu:', record);
  };

  const onSortChanged = params => {
    const sortModel = params.api.getSortModel();
    gritStore.setSortModel(sortModel);
  };

  const onFilterChanged = params => {
    const filterModel = params.api.getFilterModel();
    gritStore.setFilterModel(filterModel);
  };

  const frameworkComponents = {
    actionCellRenderer: (params) => (
      <IconButton onClick={(e) => openMenu(e, params.node.data)}>
        <MoreVert color="primary" />
      </IconButton>
    ),
  };

  const isLeadDashboard = (recordType: string) => {
    return recordType?.toUpperCase() === LEAD_OBJECT_TYPE
  }

  return (
    <>
      <div className={classes.peopleContainer}>
        {cadence.metrics.totalProspects === 0 && (
          <Grid item xs={12}>
            <Box className={classes.noStepsContainer}>
              <Typography variant="h6" color="textSecondary">
                No prospects associated with the cadence yet
              </Typography>
            </Box>
          </Grid>
        )
        }

        {cadence.metrics.totalProspects > 0 && (
          <>
            <Box display="flex" flexDirection="row" gridGap="10px">
              {globalStore.userFeatures.backOfficeLead && isLeadDashboard(cadence.recordType) &&
                <Box>
                  <SelectField
                    value={cadenceStore.gridBusinessUnit}
                    options={businessUnitOptions}
                    onChange={value => {
                      cadenceStore.gridBusinessUnit = value
                      gritStore.fetchGridData();
                    }}
                    fullWidth
                    variant={'outlined'}
                    testId={'businessUnit'}
                    style={{ height: '40px', minWidth: "100px" }}
                  />
                </Box>
              }
            </Box>
            <DataGrid
              key={`testingid`}
              className={classes.container}
              headerCheckboxSelection={true}
              suppressRowClickSelection={true}
              frameworkComponents={frameworkComponents}
              columns={columns}
              rows={gritStore.gridData.data.rows}
              onSortChanged={onSortChanged}
              onFilterChanged={onFilterChanged}
              rowHeight={45}
              checkBoxColumnPinned={true}
              enablePaginationSelectPage={true}
              showPagination={true}
              isLoading={gritStore.isLoading}
              showFilters={gritStore.showFilters}
              sortModel={gritStore.sortModel}
              filterModel={gritStore.filterModel}
              paginationData={gritStore.gridData.meta}
              setPageNumber={gritStore.setPageNumber}
            />
          </>
        )}
      </div>
    </>
  );
});
